var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"gContainer page",attrs:{"id":"Maintenance"}},[_c('b-alert',{attrs:{"variant":"warning","show":""}},[_vm._v("Application is currently unavailable due to maintenance. Please check back later.")])],1)}
var staticRenderFns = []

export { render, staticRenderFns }